import { IMasterScope } from "@/models";

import { BaseRepository } from "@/repositories";

class MasterScopeRepository extends BaseRepository<IMasterScope> {
    protected getAllErrorMessage = "Master Scopes cannot be retrieved.";

    protected getOneErrorMessage = "This Master Scope cannot be retrieved.";

    constructor() {
        super("/mdh/master-scopes");
    }
}

const masterScopeRepository = new MasterScopeRepository();

export { MasterScopeRepository, masterScopeRepository };
